import { Directive, HostBinding, Input } from '@angular/core';
import { ThasEventType } from '@thiememeulenhoff/analytics-service-client';
import { AttributeDirective } from './attribute.directive';

@Directive({
  selector: '[thasNavigation]',
})
export class NavigationDirective extends AttributeDirective {
  protected readonly type = ThasEventType.Navigation;

  @Input('thasNavigation')
  @HostBinding('attr.data-thas-navigation')
  public value?: string;
}
